// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export default {
    "dirty": false,
    "raw": "6f735bd",
    "hash": "6f735bd",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "6f735bd",
    "semverString": null
};
/* tslint:enable */
